/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Node } from '../../core/models/Node';
import { AaiChannelItem } from './AaiChannelItem';
import { AaiComponents } from './AaiComponents';
import { AaiContact } from './AaiContact';
import { AaiCorrelationId } from './AaiCorrelationId';
import { AaiDocument } from './AaiDocument';
import { AaiExternalDocumentation } from './AaiExternalDocumentation';
import { AaiHeaderItem } from './AaiHeaderItem';
import { AaiInfo } from './AaiInfo';
import { AaiLicense } from './AaiLicense';
import { AaiMessage } from './AaiMessage';
import { AaiMessageTrait } from './AaiMessageTrait';
import { AaiOAuthFlows } from './AaiOAuthFlows';
import { AaiOperation } from './AaiOperation';
import { AaiOperationTrait } from './AaiOperationTrait';
import { AaiParameter } from './AaiParameter';
import { AaiSecurityRequirement } from './AaiSecurityRequirement';
import { AaiSecurityScheme } from './AaiSecurityScheme';
import { AaiServer } from './AaiServer';
import { AaiServerVariable } from './AaiServerVariable';
import { AaiTag } from './AaiTag';
import { AaiServerBindings } from './AaiServerBindings';
import { AaiServerBindingsDefinition } from './AaiServerBindingsDefinition';
import { AaiOperationBindings } from './AaiOperationBindings';
import { AaiOperationBindingsDefinition } from './AaiOperationBindingsDefinition';
import { AaiMessageBindings } from './AaiMessageBindings';
import { AaiMessageBindingsDefinition } from './AaiMessageBindingsDefinition';
import { AaiChannelBindings } from './AaiChannelBindings';
import { AaiChannelBindingsDefinition } from './AaiChannelBindingsDefinition';
import { AaiOperationTraitDefinition } from './AaiOperationTraitDefinition';
import { AaiMessageTraitDefinition } from './AaiMessageTraitDefinition';
import { AaiSchema } from './AaiSchema';

/**
 * Interface defining a factory for creating AsyncAPI model nodes.
 * Useful for e.g. DataModelReader.
 * Common parameters:
 * - Node parent - parent node in the target model tree. You have to
 * attach the node to the parent node separately. (TODO?)
 * May be null.
 * - String key - if the node is attached to the parent as a member of a map field,
 * The child node should be aware of the key it has been referenced by.
 * This information is necessary for serialization and deserialization.
 * May be null, e.g. in case the node is reference directly via a field.
 * 
 * @author Jakub Senko <jsenko@redhat.com>
 * @class
 */
export interface IAaiNodeFactory {
    createChannelItem(parent : Node, key : string) : AaiChannelItem;

    createComponents(parent : Node) : AaiComponents;

    createContact(parent : Node) : AaiContact;

    createCorrelationId(parent : Node, key : string) : AaiCorrelationId;

    createDocument() : AaiDocument;

    createExternalDocumentation(parent : Node) : AaiExternalDocumentation;

    createHeaderItem(parent : Node) : AaiHeaderItem;

    createInfo(parent : Node) : AaiInfo;

    createLicense(parent : Node) : AaiLicense;

    createMessage(parent : Node, key : string) : AaiMessage;

    createMessageTrait(parent : Node, key : string) : AaiMessageTrait;

    createOAuthFlows(parent : Node) : AaiOAuthFlows;

    createOperation(parent : Node, key : string) : AaiOperation;

    createOperationTrait(parent : Node, key : string) : AaiOperationTrait;

    createParameter(parent : Node, key : string) : AaiParameter;

    createSecurityRequirement(parent : Node) : AaiSecurityRequirement;

    createSecurityScheme(parent : Node, key : string) : AaiSecurityScheme;

    createServer(parent : Node, key : string) : AaiServer;

    createServerVariable(parent : Node, key : string) : AaiServerVariable;

    createTag(parent : Node) : AaiTag;

    createServerBindings(parent : Node) : AaiServerBindings;

    createServerBindingsDefinition(parent : Node, key : string) : AaiServerBindingsDefinition;

    createOperationBindings(parent : Node) : AaiOperationBindings;

    createOperationBindingsDefinition(parent : Node, key : string) : AaiOperationBindingsDefinition;

    createMessageBindings(parent : Node) : AaiMessageBindings;

    createMessageBindingsDefinition(parent : Node, key : string) : AaiMessageBindingsDefinition;

    createChannelBindings(parent : Node) : AaiChannelBindings;

    createChannelBindingsDefinition(parent : Node, key : string) : AaiChannelBindingsDefinition;

    createOperationTraitDefinition(parent : Node, key : string) : AaiOperationTraitDefinition;

    createMessageTraitDefinition(parent : Node, key : string) : AaiMessageTraitDefinition;

    createSchemaDefinition(parent : Node, key : string) : AaiSchema;
}


